import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidShareIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21.7 11.3-8-8c-.4-.4-1-.4-1.4 0-.2.2-.3.4-.3.7v3.5c-5.7.5-10 5.3-10 11V20c0 .6.4 1 1 1 .3 0 .6-.1.8-.4 2-2.4 4.8-3.8 7.9-4h.3V20c0 .6.4 1 1 1 .3 0 .5-.1.7-.3l8-8c.4-.4.4-1 0-1.4Z"/>
  </SvgIcon>
}

export default SolidShareIcon
